import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { endpoints, asset } from "@/lib/api";
import { PageHeader, CTASection } from "@/components/site/Bits";
import { Reveal, ClippedImage } from "@/lib/motion";

export default function JournalIndex() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    endpoints.journal().then(setPosts).catch(() => {});
  }, []);

  const [lead, ...rest] = posts;

  return (
    <div data-testid="journal-page">
      <PageHeader
        eyebrow="The Journal"
        title={["Notes on", "hospitality."]}
        intro="Essays and observations on the craft of hosting, the places we work, and the small ceremonies that make an evening."
        testid="journal-header"
      />

      {lead && (
        <section className="aria-container pb-20 md:pb-28">
          <Link to={`/journal/${lead.slug}`} className="group grid grid-cols-1 items-center gap-10 md:grid-cols-12 md:gap-16" data-testid="journal-lead">
            <div className="md:col-span-7">
              <ClippedImage src={lead.cover_image} alt={lead.title} aspect="aspect-[16/10]" />
            </div>
            <div className="md:col-span-5">
              <div className="text-[0.7rem] uppercase tracking-[0.24em] text-aria-brass">{lead.category} · {lead.read_time}</div>
              <h2 className="mt-5 font-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] text-aria-ink transition-colors group-hover:text-aria-cocoa">{lead.title}</h2>
              <p className="mt-6 max-w-md font-light leading-relaxed text-aria-cocoa/75">{lead.excerpt}</p>
              <span className="mt-8 inline-block aria-link font-display text-2xl text-aria-ink">Read the essay</span>
            </div>
          </Link>
        </section>
      )}

      <section className="aria-container pb-28 md:pb-40">
        <div className="grid grid-cols-1 gap-x-8 gap-y-16 md:grid-cols-2 lg:grid-cols-3">
          {rest.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.1}>
              <Link to={`/journal/${p.slug}`} className="group block" data-testid={`journal-card-${p.slug}`}>
                <div className="relative overflow-hidden aspect-[3/2]">
                  <img src={asset(p.cover_image)} alt={p.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-105" />
                </div>
                <div className="mt-5 text-[0.68rem] uppercase tracking-[0.22em] text-aria-brass">{p.category} · {p.read_time}</div>
                <h3 className="mt-3 font-display text-2xl md:text-3xl leading-snug text-aria-ink">{p.title}</h3>
                <p className="mt-3 font-light text-aria-cocoa/70">{p.excerpt}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
